import { Component, Inject, OnInit, Optional } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { MatSnackBar } from '@angular/material/snack-bar';
import { ApiService } from 'src/app/api.service';

@Component({
  selector: 'app-edit-bm',
  templateUrl: './edit-bm.component.html',
  styleUrls: ['./edit-bm.component.scss']
})
export class EditBmComponent implements OnInit {
  bmIdToUpdate;
  bmData = {};
  allGroups = [];
  selectedGroups = [];
  rowList = ['nihar', 'kavin', 'test'];
  searchText;

  constructor(
    public dialogRef: MatDialogRef<EditBmComponent>,
    @Optional() @Inject(MAT_DIALOG_DATA) public data: any,
    private _apiService: ApiService,
    private _snackBar: MatSnackBar
  ) {
    // this.bmIdToUpdate = data.bmId;
    this.bmData = data.bmData;
   }

  ngOnInit(): void {
    this._apiService.getGroupList().subscribe(res => {
      if (res) {
        this.allGroups = res;
        console.log(res);
        // this.dialogRef.close();
      }
    },
    (error)=>{
      console.log(error);
    });
  }

  close(): void {
    this.dialogRef.close();
  }

  mychange(e){}

  updateBoardMember(userData){
      let bmInfo = {
        "user_id":userData.id,
        "name":userData.first_name,
        "phone":userData.phone,
        "group_id":[]
      }
      this._apiService.updateBoardMember(bmInfo).subscribe(res => {
        if (res) {
          this.dialogRef.close();
          console.log(res);
        }
      },
      (error)=>{
        console.log(error);
      });
    }
    
  

}
